import React, { useEffect, useState, useRef } from "react";

const Input = ({
  submitFunction,
  incorrectEmail,
  incorrectEmailText,
  label,
}) => {
  const [text, setText] = useState(null);
  const inputRef = useRef(null);

  // useEffect(() => {
  //     effect
  //     return () => {
  //         cleanup
  //     };
  // }, [input]);
  return (
    <div className="input-ctn">
      {incorrectEmail && (
        <div className="input-error">{incorrectEmailText}</div>
      )}
      <label
        htmlFor=""
        style={{
          top: text ? "5px" : "",
          fontSize: text ? "10px" : "",
        }}
      >
        {label}
      </label>
      <input
        type="text"
        ref={inputRef}
        // placeholder={"Enter Registered Email"}
        // defaultValue="2livebre615@gmail.com"
        // value={text}
        onChange={(event) => {
          setText(event.target.value);
        }}
      />
      <button
        className="add-btn"
        onClick={() => {
          submitFunction(text);
          console.log("clicked");
        }}
      >
        <svg viewBox="0 0 29 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.953857 10.3999H27.2604" />
          <path d="M18.0532 0.799903L27.3539 10.3999L18.0532 19.9999" />
        </svg>
      </button>
    </div>
  );
};

export default Input;
